import React, { useState } from "react"
import PropTypes from "prop-types"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography
} from "@mui/material"
import { FaTimes } from "react-icons/fa"
import { Box } from "@mui/system"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}))

const BootstrapDialogTitle = props => {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <FaTimes />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
}

export default function AboutMeText({
  ModalTitle,
  // handleYesButton,
  u_id,
  AboutMeText,
  handleChange,
  handleOkButton,
  onClose
}) {
  const [open, setOpen] = useState(true)
  const handleClose = () => {
    setOpen(false)
    onClose && onClose();
  }

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      open={open}
    >
      <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose}>
        {ModalTitle}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        {AboutMeText && (
          <textarea
            // component='textArea'
            // sx={{
            //   height: 233,
            // maxWidth: 350
            //   maxHeight: { xs: 233, md: 167 },
            //   maxWidth: { xs: 350, md: 250 }
            // }}
            // align="center"
            style={{
              wordWrap: "break-word !important",
              height: "233px",
              width: "350px",
              maxWidth: "350px",
              padding: "10px",
              maxheight: "350px"
            }}
            onChange={handleChange}
            defaultValue={AboutMeText}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={()=>{
          handleOkButton(u_id);
        }}>
          OK
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}
